/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CalcInputs } from '../models/CalcInputs';
import type { FinderResultDto } from '../models/FinderResultDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class CalcService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param requestBody
     * @returns FinderResultDto OK
     * @throws ApiError
     */
    public runCalculation(
        requestBody?: CalcInputs,
    ): CancelablePromise<Array<FinderResultDto>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/p/Calc/RunCalculation',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
